import { motion } from "framer-motion";
import { StaggerContainer, StaggerItem } from "../../../components/animations/AnimatedElements";

const quickLinks = [
  { label: "회사 소개", href: "#about" },
  { label: "연혁", href: "#history" },
  { label: "비전·사업 영역", href: "#vision" },
  { label: "제품·서비스", href: "#products" },
  { label: "솔루션 소개", href: "#solutions" },
  { label: "협력 문의", href: "#contact" },
];

const contactItems = [
  { icon: "ri-building-line", text: "CITY-AI(씨티에이아이) 주식회사" },
  { icon: "ri-user-line", text: "대표이사 정종모" },
  { icon: "ri-mail-line", text: "jjongmo@cityai.kr" },
  { icon: "ri-phone-line", text: "010-3460-3208" },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-brand-darker border-t border-cyan-900/20 pt-16 pb-8" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <img
              src="/cityai-logo-full.png"
              alt="CITY-AI 로고"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed mb-5 max-w-sm">
              AI를 통해 기술과 사람, 그리고 사회를 연결하며 미래 산업을 준비하는 <strong className="text-gray-400">All AI Agent 기업</strong>, CITY-AI 주식회사입니다.
            </p>
            <p className="text-gray-600 text-xs italic mb-4">"우리 생활을 창조하다"</p>
            <motion.a
              href="http://pf.kakao.com/_GLQZX/chat"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#FEE500] hover:bg-[#FFD700] text-gray-900 text-sm font-semibold rounded-md transition-all duration-200 cursor-pointer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className="ri-kakao-talk-fill" />
              카카오톡 문의
            </motion.a>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h4 className="text-white text-sm font-semibold mb-4">바로가기</h4>
            <StaggerContainer className="space-y-2" staggerDelay={0.05}>
              {quickLinks.map((link) => (
                <StaggerItem key={link.href}>
                  <motion.a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-gray-500 hover:text-cyan-400 text-sm transition-colors cursor-pointer inline-block"
                    whileHover={{ x: 5 }}
                  >
                    {link.label}
                  </motion.a>
                </StaggerItem>
              ))}
            </StaggerContainer>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h4 className="text-white text-sm font-semibold mb-4">연락처</h4>
            <StaggerContainer className="space-y-3" staggerDelay={0.05}>
              {contactItems.map((item) => (
                <StaggerItem key={item.text}>
                  <li className="flex items-center gap-2.5 text-gray-500 text-sm list-none">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-cyan-600 text-sm`} />
                    </div>
                    {item.text}
                  </li>
                </StaggerItem>
              ))}
            </StaggerContainer>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-cyan-900/20 pt-6 flex flex-col lg:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            © 2024 CITY-AI(씨티에이아이) 주식회사. All Rights Reserved.
          </p>
          <motion.div
            className="flex items-center gap-2"
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 3, repeat: Infinity }}
          >
            <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full" />
            <span className="text-gray-600 text-xs">AI Agent 기술 운영 중</span>
          </motion.div>
        </div>
      </div>
    </footer>
  );
}
